import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Loading...', fullScreen = true, size = 'medium' }) => {
  const spinnerClass = `loading-spinner ${size}`;
  const containerClass = fullScreen ? 'loading-spinner-fullscreen' : 'loading-spinner-inline';

  return (
    <div className={containerClass}>
      <div className="loading-spinner-wrapper">
        <div className={spinnerClass}></div>
        {message && <p className="loading-spinner-text">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;

